export type ApiErrorKind =
  | "cancelled"
  | "timeout"
  | "network"
  | "http"
  | "parse";

export interface ApiErrorContext {
  kind: ApiErrorKind;
  message: string;
  status?: number;
  code?: string;
  correlationId?: string;
  details?: unknown;
  cause?: unknown;
}

export class ApiError extends Error {
  readonly kind: ApiErrorKind;
  readonly status?: number;
  readonly code?: string;
  readonly correlationId?: string;
  readonly details?: unknown;

  constructor(context: ApiErrorContext) {
    super(context.message, { cause: context.cause });
    this.name = "ApiError";
    this.kind = context.kind;
    this.status = context.status;
    this.code = context.code;
    this.correlationId = context.correlationId;
    this.details = context.details;
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
